import ExtendableError from './ExtendableError';
export default class NotImplementedError extends ExtendableError {

}